import React from 'react';
import { WavesIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy-deep py-16 px-6" data-id="element-118" data-mp="3gf96f0gd6eb2">
      <div className="max-w-6xl mx-auto" data-id="element-119" data-mp="3ggtxgg3gzf46">
        {/* Wave divider */}

        {/* Sail logomark — already-white SVG, plain img */}
        <div className="flex justify-center mb-6" data-id="element-120" data-mp="36pft9v0kpr4p">
          <img src="https://cdn.magicpatterns.com/uploads/wAdPA7wgvdq7XrQn29qvhh/FCh_logo_White.svg" alt="Future Challenge logo" width="64" height="64" className="h-16 w-auto block" data-id="element-121" data-mp="36q953aee36tp" />
        </div>

        {/* Wordmark — clean re-exported SVG, white via filter */}
        <div className="flex justify-center mb-8" data-id="element-122" data-mp="3lgop4lv2k8qa">
          <img src="https://cdn.magicpatterns.com/uploads/6ikzqbMg3YKiQTBTLZDAFn/FutureChallenge.svg" alt="FUTURE CHALLENGE" className="block h-6 md:h-8 w-auto opacity-90" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-123" data-mp="3qcdu54puyhtz" />
        </div>

        {/* Copyright */}
        <div className="text-center text-white/60 text-sm" data-id="element-124" data-mp="3lbddywk4gfne">
          © 2026 Future Challenge · Soukromá akce
        </div>
      </div>
    </footer>;
}